'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Lockup from 'components/blocks/shared/Lockup';
import Img from 'components/ui/Img';
import EntryLink from 'components/ui/Link/EntryLink';

import { blockRootProps } from 'utils';

import styles from './BlockProductHero.module.scss';

const BlockProductHero = ({
    __typename,
    anchorId,
    icon,
    eyebrow,
    headline,
    richText,
    paragraph,
    cta,
    hideCta,
    eyebrowColor = 'cream',
    image,
    imageLarge,
    flushBottom,
    flushTop,
    textOnRight,
    firstBlock = false,
}) => {
    if (!image?.url || !imageLarge?.url) {
        return null;
    }

    return (
        <section
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.root, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
                [styles.textOnRight]: textOnRight,
            })}
            style={{
                '--text-color': `var(--colors-${eyebrowColor})`,
            }}
        >
            <div className={styles.inner}>
                <EntryLink
                    className={styles.contentWrapper}
                    entry={hideCta && cta && 'link' in cta ? cta.link : ''}
                >
                    <div className={styles.innerWrapperInner}>
                        <div className={styles.heroImgBlock}>
                            <Img
                                className={styles.img}
                                src={image.url}
                                fallbackImageWidth={768}
                                alt={image.description || ''}
                                width={image.width ?? undefined}
                                height={image.height ?? undefined}
                                priority={firstBlock}
                                customSources={[
                                    {
                                        breakpoint: 768,
                                        src: imageLarge.url,
                                        imageWidth: 1420,
                                    },
                                    {
                                        src: image.url,
                                        imageWidth: 768,
                                    },
                                ]}
                            />
                        </div>
                        <div className={styles.innerWrapper}>
                            <div className={styles.textBlock}>
                                <Lockup
                                    icon={icon}
                                    eyebrow={{
                                        text: eyebrow,
                                    }}
                                    headline={{
                                        as: firstBlock ? 'h1' : 'h2',
                                        text: headline,
                                    }}
                                    copy={{ text: paragraph || richText }}
                                    ctas={!hideCta && cta ? cta : undefined}
                                    theme="Medium"
                                />
                            </div>
                        </div>
                    </div>
                </EntryLink>
            </div>
        </section>
    );
};

BlockProductHero.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    blockEyebrow: PropTypes.string,
    blockHeadline: PropTypes.string,
    cta: PropTypes.object,
    ctas: PropTypes.array,
    eyebrow: PropTypes.string,
    eyebrowColor: PropTypes.string,
    flushBottom: PropTypes.bool,
    flushTop: PropTypes.bool,
    headline: PropTypes.string,
    headlineColor: PropTypes.string,
    hideCta: PropTypes.bool,
    icon: PropTypes.object,
    image: PropTypes.object,
    imageLarge: PropTypes.object,
    paragraph: PropTypes.string,
    richText: PropTypes.object,
    textOnRight: PropTypes.bool,
    firstBlock: PropTypes.bool,
    lastBlock: PropTypes.bool,
    theme: PropTypes.oneOf(['Featured', 'Default', 'Display']),
};

export default BlockProductHero;
